import * as Yup from 'yup';
import { ContextService } from '../../../hoc/context/product/context';
import { EnrollmentContextService } from '../../../hoc/context/enrollment/enrollment-context';
import { PerformerConstants } from '../../../hoc/constants/performer.constants';
import { commonValidations } from './validations-common';

export type error = {
	message: string;
};
export const validations = (
	ctxt: ContextService,
	enrollmentCtxt: EnrollmentContextService
) => {
	return Yup.object().shape({
		...commonValidations(ctxt, enrollmentCtxt),
		...(ctxt.json.getForm('caregiverDetails') && enrollmentCtxt.input.performer === PerformerConstants.caregiver
			? commonValidations(
				ctxt,
				enrollmentCtxt,
				PerformerConstants.caregiver
			)
			: {}
		)
	});
};
	
